import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useUser } from './context/UserContext';
import MainMap from './components/Map/MainMap';
import AdminPanel from './components/Admin/AdminPanel';
import AdminLogin from './components/Admin/AdminLogin';
import Login from './components/Login';
import { Toaster } from 'react-hot-toast';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentCanceled from './components/PaymentCanceled';
import LegalGateway from './components/LegalGateway';

function AppContent() {
  const { user, loading } = useUser();

   const hasAgreed = localStorage.getItem('croatoanLegalAgreed') === 'true';

  if (loading) {
    return (
      <div className="h-screen bg-black flex items-center justify-center">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }

  if (!hasAgreed && !window.location.pathname.startsWith('/admin')) {
    return <LegalGateway />;
  }

  return (
    <Routes>
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/payment-canceled" element={<PaymentCanceled />} />
      <Route
        path="/login"
        element={!user ? <Login /> : <Navigate to="/" />}
      />
      <Route
        path="/admin"
        element={!user ? <AdminLogin /> : <Navigate to="/admin/dashboard" />}
      />
      <Route
        path="/admin/dashboard"
        element={user ? <AdminPanel /> : <Navigate to="/admin" />}
      />

      <Route
        path="/"
        element={user ? <MainMap /> : <Navigate to="/login" />}
      />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#FFFFFF',
            color: '#111111',
            border: '1px solid #D8D8D2',
            borderRadius: 14,
            boxShadow: '0 18px 50px rgba(0, 0, 0, 0.18)',
            fontFamily: '"Inter Tight", sans-serif',
            fontSize: '14px',
          },
          success: {
            style: {
              background: '#FFFFFF',
              border: '1px solid #D8D8D2',
            },
          },
          error: {
            style: {
              color: '#FFFFFF',
              background: '#111111',
              border: '1px solid #FF8000',
            },
          },
        }}
      />
    </Router>
  );
}
